import React from "react";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { chatPinnedStore } from "../stores/chatPinned";
import { chatPinnedAddModalStore } from "../stores/chatPinnedAddModal";
import { chatPinnedEditModalStore } from "../stores/chatPinnedEditModal";
/* ------- */

class ChatPinned extends React.Component {
	constructor(props) {
		super(props);
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadChatPinnedList();
			}, 0);
		}
	};

	componentDidMount() {
		this.props.Interface.loadChatPinnedList();
	}

	render() {
		return (
			<>
				{this.props.chatPinned.loaded && this.props.chatPinned.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.chatPinned.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.chatPinned.error.code} | request timestamp: {this.props.chatPinned.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.chatPinned.loaded}
					sortingColumn={{ sortingField: this.props.chatPinned.sorting.sortingColumn.column }}
					sortingDescending={this.props.chatPinned.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setChatPinned({
							...this.props.chatPinned,
							sorting: {
								...this.props.chatPinned.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField,
								},
								isDescending: sorting.detail.isDescending,
							},
						});

						setTimeout(() => {
							this.props.Interface.loadChatPinnedList();
						}, 250);
					}}
					columnDefinitions={[
						{
							maxWidth: 80,
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setChatPinnedEditModal({
												...this.props.chatPinnedEditModal,
												show: true,
												id: item.id,
												message: item.message,
												isClickable: Boolean(item.isClickable),
												link: item.link ?? "",
												type: this.props.chatPinnedEditModal.currentOption.type.filter((element) => element.value === item.type)[0],
												messageType: this.props.chatPinnedEditModal.currentOption.messageType.filter((element) => element.value === item.messageType)[0],
												status: this.props.chatPinnedEditModal.currentOption.status.filter((element) => element.value === item.status)[0],
												durationMinutes: item.durationMinutes,
												intervalMinutes: item.intervalMinutes,
												lastDisplayedDate: new Date(item.lastDisplayed).toLocaleDateString().split(".").reverse().join("-"),
												lastDisplayedTime: new Date(item.lastDisplayed).toLocaleTimeString(),
											});
										}, 0);
									}}
									children={item.id}
								/>
							),
						},
						{ id: "message", maxWidth: 150, header: "Message", sortingField: "message", cell: (item) => item.message },
						{ id: "messageType", maxWidth: 150, header: "Message Translation Type", sortingField: "messageType", cell: (item) => item.messageType },
						{ id: "durationMinutes", header: "Duration minutes", sortingField: "durationMinutes", cell: (item) => (item.type === "interval" ? item.durationMinutes : "inf") },
						{ id: "intervalMinutes", header: "Interval minutes", sortingField: "intervalMinutes", cell: (item) => (item.type === "interval" ? item.intervalMinutes : "inf") },
						{
							id: "type",
							header: "Type",
							sortingField: "type",
							cell: (item) => item.type,
						},
						{
							id: "status",
							header: "Status",
							sortingField: "status",
							cell: (item) => <Box className={[this.props.styles["status"], this.props.styles[item.status === "enabled" ? "green" : ""]].join(" ")}>{item.status}</Box>,
						},
						{ id: "lastDisplayed", header: "Last displayed", sortingField: "lastDisplayed", cell: (item) => <>{item.lastDisplayed ? new Date(item.lastDisplayed).toLocaleDateString() + " " + new Date(item.lastDisplayed).toLocaleTimeString() : "Not view"}</> },
						{ id: "createdAt", header: "Сreated At", cell: (item) => <>{new Date(item.createdAt).toLocaleDateString() + " " + new Date(item.createdAt).toLocaleTimeString()}</> },
					]}
					items={this.props.chatPinned.data}
					pagination={
						<Pagination
							disabled={!this.props.chatPinned.loaded}
							currentPageIndex={this.props.chatPinned.pagination.current}
							pagesCount={this.props.chatPinned.pagination.total}
							onChange={(page) => {
								this.props.setChatPinned({ ...this.props.chatPinned, pagination: { ...this.props.chatPinned.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadChatPinnedList();
								}, 250);
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.chatPinned.preferences.perPage }}
							preferences={{ pageSize: this.props.config.chatPinned.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("chatPinned.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, chatPinned: { ...this.props.config.chatPinned, perPage: preferences.detail.pageSize } });

								setTimeout(() => {
									this.props.Interface.loadChatPinnedList();
								}, 250);
							}}
						/>
					}
					filter={<Box margin={{ bottom: "m" }} children={<Grid gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]} />} />}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Chat message pinned"
									counter={<>({this.props.chatPinned.pagination.count})</>}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												disabled={!this.props.chatPinned.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													setTimeout(() => {
														this.props.setChatPinnedAddModal({ ...this.props.chatPinnedAddModal, show: true });
													}, 0);
												}}
												variant="primary"
												children="Add message chat pinned"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>
					}
					empty="No chatPinned found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const chatPinned = useRecoilValue(chatPinnedStore);
		const setChatPinned = useSetRecoilState(chatPinnedStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const chatPinnedEditModal = useRecoilValue(chatPinnedEditModalStore);
		const setChatPinnedEditModal = useSetRecoilState(chatPinnedEditModalStore);
		const chatPinnedAddModal = useRecoilValue(chatPinnedAddModalStore);
		const setChatPinnedAddModal = useSetRecoilState(chatPinnedAddModalStore);
		return <Component {...props} chatPinnedEditModal={chatPinnedEditModal} setChatPinnedEditModal={setChatPinnedEditModal} chatPinnedAddModal={chatPinnedAddModal} setChatPinnedAddModal={setChatPinnedAddModal} chatPinned={chatPinned} setChatPinned={setChatPinned} config={config} setConfig={setConfig} />;
	};
}

export default withRecoil(ChatPinned);
